import * as DG from 'datagrok-api/dg';
export const NEWICK_EMPTY = ';';
export var TAGS;
(function (TAGS) {
    TAGS["NEWICK"] = ".newick";
    TAGS["NEWICK_JSON"] = ".newick_json";
    TAGS["OBJECTS"] = ".newick_objects";
    TAGS["NEWICK_LEAF_COL_NAME"] = ".newickLeafColumn";
})(TAGS || (TAGS = {}));
export var TreeColorNames;
(function (TreeColorNames) {
    TreeColorNames["Main"] = "Main";
    TreeColorNames["Light"] = "Light";
    TreeColorNames["Current"] = "Current";
    TreeColorNames["MouseOver"] = "MouseOver";
    TreeColorNames["Selection"] = "Selection";
})(TreeColorNames || (TreeColorNames = {}));
export var DistanceMetric;
(function (DistanceMetric) {
    DistanceMetric["Euclidean"] = "euclidean";
    DistanceMetric["Manhattan"] = "manhattan";
})(DistanceMetric || (DistanceMetric = {}));
export var LinkageMethod;
(function (LinkageMethod) {
    LinkageMethod["Single"] = "single";
    LinkageMethod["Complete"] = "complete";
    LinkageMethod["Average"] = "average";
    LinkageMethod["Weighted"] = "weighted";
    LinkageMethod["Centroid"] = "centroid";
    LinkageMethod["Median"] = "median";
    LinkageMethod["Ward"] = "ward";
})(LinkageMethod || (LinkageMethod = {}));
export const TreeDefaultPalette = {
    [TreeColorNames.Main]: DG.Color.categoricalPalette[12],
    [TreeColorNames.Light]: DG.Color.categoricalPalette[13],
    [TreeColorNames.Current]: DG.Color.currentRow,
    [TreeColorNames.MouseOver]: DG.Color.mouseOverRows,
    [TreeColorNames.Selection]: DG.Color.selectedRows,
};
//# sourceMappingURL=consts.js.map